import React from 'react';
import { Spinner } from 'reactstrap';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Loader = (props: any) => {
    return (
        <React.Fragment>
            {/* <div className="d-flex justify-content-center mx-2 mt-2"> */}
            <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner color="primary" children="Loading..." />
            </div>
            {toast.error(props.error, { position: 'top-right', hideProgressBar: false, progress: undefined, toastId: '' })}
        </React.Fragment>
    );
};

export default Loader;
